export default __webpack_public_path__ + "static/media/minis_icon.3bbefb14.svg";